<template>
  <main-layout>
    <section class="article-detail">
      <div class="wrap">
        <div class="left">
          <h4>{{ articleDetail.title }}</h4>
          <div class="userInfo">
            <router-link
              class="user"
              target="_blank"
              :class="{ userType2: userDomain && userDomain.userType === 2 && userDomain.isCertification === 1 }"
              :to="'/peopleCenter/' + (userDomain ? userDomain.id : null)"
            >
              <img
                :src="
                  (userDomain ? articleDetail.avatar: '')
                    | imageUrl('/static/profile_img_default.png', 190, 190)
                "
              />
              <span class="nickname">{{ articleDetail ? articleDetail.nickName : ''}}</span>
              <button
                class="member-focus"
                @mouseenter="isTre1 = true"
                @mouseleave="isTre1 = false"
                v-bind:class="{
                  following: allDetail.isFollow,
                  'add-follow-2': !allDetail.isFollow,
                }"
                @click.prevent.stop="Follow(allDetail)"
              >
                {{
                  !allDetail.isFollow
                    ? $t("global.关注")
                    : isTre1
                    ? $t("global.取消关注")
                    : $t("global.已关注")
                }}
              </button>
              <div class="view-wrap" @click.prevent>
                <!-- <img class="view-icon" src="/static/home/images/eyes.png" />
                <span class="view">{{articleDetail.viewCount || 0}}</span> -->
                <!-- <span class="time">{{
                  articleDetail.articleReleaseTime | dateToNow(language)
                }}</span> -->
              </div>
            </router-link>
            <router-link
              class="edit"
              :to="`/article/edit?id=${questionId}`"
              v-if="isUser"
            >
              <span>{{ $t("global.修改") }}</span>
            </router-link>
          </div>
          <div class="content clearfix" v-html="articleDetail.content"></div>
          <div class="bottom" :class="{ isFixed: isFixed }">
            <div class="bottom-user">
              <router-link
                class="user"
                target="_blank"
                :class="{ userType2: userDomain && userDomain.userType === 2 && userDomain.isCertification === 1 }"
                :to="'/peopleCenter/' + (userDomain ? userDomain.id : null)"
              >
                <img
                  :src="
                    (userDomain ? articleDetail.avatar : '')
                      | imageUrl('/static/profile_img_default.png', 190, 190)
                  "
                />
                <span class="nickname">{{ userDomain ? articleDetail.nickName : '' }}</span>
                <button
                  class="member-focus"
                  @mouseenter="isTre2 = true"
                  @mouseleave="isTre2 = false"
                  v-bind:class="{
                    following: allDetail.isFollow,
                    'add-follow-2': !allDetail.isFollow,
                  }"
                  @click.prevent.stop="Follow(allDetail)"
                >
                  {{
                    !allDetail.isFollow
                      ? $t("global.关注")
                      : isTre2
                      ? $t("global.取消关注")
                      : $t("global.已关注")
                  }}
                </button>
              </router-link>
            </div>
            <div class="like-collect">
              <ul>
                <li @click="like">
                  <img
                    src="/static/v2/article/article_clap.png"
                    v-if="!allDetail.isLike"
                    alt
                  />
                  <img
                    src="/static/v2/article/article_clap_active.png"
                    v-if="allDetail.isLike"
                    alt
                  />
                  <span :class="{ isActive: allDetail.isLike }">{{
                    articleDetail.likeCount
                  }}</span>
                </li>
                <li @click="topTo">
                  <img src="/static/v2/article/article_comment.png" alt />
                  <span>{{ replyLength }}</span>
                </li>
                <li @click="collect">
                  <img
                    src="/static/v2/article/article_save.png"
                    v-if="!allDetail.isCollect"
                    alt
                  />
                  <img
                    src="/static/v2/article/article_save_active.png"
                    v-if="allDetail.isCollect"
                    alt
                  />
                  <span :class="{ isActive: allDetail.isCollect }">{{
                    articleDetail.collectionCount
                  }}</span>
                </li>
                <li>
                  <el-popover placement="bottom" width="240" v-model="visible">
                    <share :config="config"></share>
                    <img
                      slot="reference"
                      src="/static/v2/article/article_share.png"
                      @click="shareCkeck"
                    />
                  </el-popover>
                </li>
                <li>
                  <el-popover
                    class="el-popper-more"
                    placement="bottom"
                    width="74"
                    v-model="handleVisible"
                  >
                    <edit-or-report
                      :id="questionId"
                      :isUser="isUser"
                      @delete="deleteArticle"
                      @report="reportArticle"
                    />
                    <img
                      slot="reference"
                      src="/static/v2/article/article_more.png"
                    />
                  </el-popover>
                </li>
              </ul>
            </div>
          </div>
          <div class="comment">
            <h4>{{ $t("global.评论") }}</h4>
            <div class="textarea" v-if="isLogin">
              <img
                :src="
                  $store.state.peopleMessage.avatar
                    | imageUrl('/static/profile_img_default.png', 80, 80)
                "
                alt
              />
              <el-input
                type="textarea"
                :rows="2"
                :placeholder="$t('global.发表您的评论…')"
                v-model="comment"
              ></el-input>
              <el-button @click="createAnswer">{{
                $t("global.发表评论")
              }}</el-button>
            </div>
            <div class="no-login" v-else>
              <p>
                {{ $t("global.请") }}
                <span @click="navToLogin">{{ $t("global.登录") }}</span>
                {{ $t("global.或") }}
                <span @click="navToReg">{{ $t("global.注册") }}</span>
                {{ $t("global.再发表评论") }}
              </p>
            </div>
            <div class="reply-wrap">
              <span v-if="replyLength > 0">{{
                $t("global.共x条评论", { count: replyLength })
              }}</span>
              <ul class="reply-list" v-if="replyLength > 0">
                <li v-for="(item, index) in replyList" :key="index">
                  <reply-card
                    :isUser="isUser"
                    :item="item"
                    :imageWidth="80"
                    @refresh="refresh"
                    @like="answerLike(item)"
                  />
                  <ul class="children" v-if="item.childDomain">
                    <li v-for="(it, i) in item.childDomain.list" :key="i">
                      <reply-card
                        :isUser="isUser"
                        :item="it"
                        :imageWidth="60"
                        :isChild="true"
                        @refresh="refresh"
                        :parentId="item.id"
                        @like="answerLike(it)"
                      />
                    </li>
                    <li
                      @click="showMoreChild(item, index)"
                      class="show-more-child"
                      v-if="
                        item.childDomain.totalRecord >
                        item.childDomain.list.length
                      "
                    >
                      {{
                        $t("global.查看全部x条回复", {
                          count:
                            item.childDomain.totalRecord -
                            item.childDomain.list.length,
                        })
                      }}
                    </li>
                  </ul>
                </li>
              </ul>
              <div class="reply-more" v-if="replyLength > replyList.length">
                <div @click="showMoreReply">
                  <span>{{ $t("global.查看更多") }}</span>
                </div>
              </div>
              <div class="reply-empty" v-if="!replyLength">
                <img src="/static/v2/article/article_comment_empty.png" alt />
                <span>{{ $t("global.还没有评论") }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="user-fllow">
            <router-link
              target="_blank"
              :class="{ userType2: userDomain && userDomain.userType === 2 && userDomain.isCertification === 1 }"
              :to="'/peopleCenter/' + (userDomain ? userDomain.id : null)"
            >
              <img
                :src="
                  (articleDetail ? articleDetail.avatar : '')
                    | imageUrl('/static/profile_img_default.png', 160, 160)
                "
                alt
              />
              <h4>{{ articleDetail ? articleDetail.nickName : '' }}</h4>
            </router-link>
            <p>{{ userDomain ? userDomain.signature : '' }}</p>
            <button
              class="member-focus"
              @mouseenter="isTre3 = true"
              @mouseleave="isTre3 = false"
              v-bind:class="{
                following: allDetail.isFollow,
                'add-follow': !allDetail.isFollow,
              }"
              @click.prevent.stop="Follow(allDetail)"
            >
              {{
                !allDetail.isFollow
                  ? $t("global.关注")
                  : isTre3
                  ? $t("global.取消关注")
                  : $t("global.已关注")
              }}
            </button>
          </div>
          <div class="hot-article" v-if="articleList.length > 0">
            <strong>
              {{ $t("global.热门文章") }}
              <router-link to="/article/edit">
                <span class="article-create">{{ $t("global.写文章") }}</span>
              </router-link>
            </strong>
            <ul class="article-list">
              <li v-for="article in articleList" :key="article.createTime">
                <p
                  @click="toLinks(article.id)"
                  class="titles"
                  style="
                    display: -webkit-box;
                    -webkit-line-clamp: 2;
                    -webkit-box-orient: vertical;
                    line-clamp: 2;
                  "
                >
                  {{ article.title }}
                </p>
                <div
                  class="userinfor"
                  :class="{ userType2: article.userType === 2 && article.isCertification === 1 }"
                >
                  <router-link
                    target="_blank"
                    :to="`/peopleCenter/${article.userId}`"
                  >
                    <img
                      :src="
                        article.avatar
                          | imageUrl('/static/profile_img_default.png', 42, 42)
                      "
                    />
                    <span>{{ article.userNickName }}</span>
                  </router-link>
                  <!-- <div class="userright">
                    <img src="/static/home/images/eyes.png" />
                    <span>{{article.viewCount}}</span>
                  </div> -->
                </div>
              </li>
            </ul>
            <div class="article-list-all">
              <router-link to="/article" class="showAllArticle">
                <span>{{ $t("global.查看全部") }}</span>
              </router-link>
            </div>
          </div>
          <div class="hot-subject" v-if="aboutCommunity.length > 0">
            <strong>{{ $t("global.相关频道") }}</strong>
            <ul class="subject-list">
              <li v-for="item in aboutCommunity" :key="item.id">
                <router-link target="_blank" :to="'/subjectdetail/' + item.id">
                  <img :src="item.thumb | imageUrl('', 130, 130)" />
                  <div>
                    <p>{{ item.title }}</p>
                    <div class="learning">
                      <span>{{ $t("global.视频") }}</span
                      ><b>{{ item.videoCount }}</b
                      ><span>{{ $t("global.成员") }}</span
                      ><b>{{ item.memberCount }}</b>
                    </div>
                  </div>
                </router-link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <report-dialog
        :questionId="questionId"
        report-type="0"
        :report-visible="reportVisible"
        @close-after="reportVisible = false"
      ></report-dialog>
    </section>
  </main-layout>
</template>

<script>
import MainLayout from "@/layouts/MainLayout";
import Header from "@/components/v2/Header";
import Share from "@/components/v2/Share";
import EditOrReport from "@/components/v2/EditOrReport";
import ReplyCard from "@/components/v2/ReplyCard";
import ReportDialog from "@/components/topic/ReportDialog";
export default {
  metaInfo() {
    return {
      title: this.$t("video.文章详情") + " | MANA"
    };
  },
  components: {
    MainLayout,
    Header,
    Share,
    EditOrReport,
    ReplyCard,
    ReportDialog
  },
  data() {
    return {
      isTre1: false,
      isTre2: false,
      isTre3: false,
      config: {},
      articleDetail: {},
      userDomain: {},
      allDetail: {},
      questionId: null,
      articleList: [],
      aboutCommunity: [],
      comment: "",
      replyList: [],
      replyLength: 0,
      visible: false,
      handleVisible: false,
      isUser: false,
      pageIndex: 1,
      pageSize: 5,
      childPageSize: 5,
      isLogin: false,
      reportVisible: false,
      isFixed: true
    };
  },
  mounted() {
    if (this.$route.query.type) {
      this.buriedPoint(25, this.$route.params.id);
    } else {
      this.buriedPoint(43, this.$route.params.id);
    }
    this.init();
    this.$nextTick(()=>{
      document.documentElement.style.fontSize = 16 + 'px'
    })
  },
  computed: {
    language() {
      return this.$language();
    }
  },
  watch: {
    $route() {
      this.init();
    }
  },
  beforeDestroy() {
    document.removeEventListener("scroll", this.changeScroll);
    var r = document.documentElement;
    var a = r.getBoundingClientRect().width;
        a > 1920 && (a = 1920),
          (rem = a / 23),
          (r.style.fontSize = (rem < 60 ? 60 : rem) + "px");
  },
  methods: {
    init() {
      this.questionId = this.$route.params.id;
      this.getDetail();
      this.getArticleList();
      this.getCommunity();
      this.getReply();
      this.saveViewCount();
      this.isLogin = !!localStorage.getItem("auth_token");
      document.addEventListener("scroll", this.changeScroll, false);
    },
    changeScroll() {
      const offsetHeight =
        document.querySelector(".left .content") &&
        document.querySelector(".left .content").offsetHeight;
      const scrollTop = document.querySelector("html").scrollTop;
      const windowHeight = document.querySelector("html").offsetHeight;
      this.isFixed = scrollTop < offsetHeight - windowHeight + 310;
    },
    saveViewCount() {
      const url = `/api/article/saveViewCount`;
      const params = {
        domainId: this.questionId,
        domainType: 4,
        type: 8,
        source: 4,
        sourceUrl: location.href
      };
      this.$http.post(url, params).then(res => {
        if (res.code === "OK") {
        }
      });
    },
    topTo() {
      document.querySelector("html").scrollTop =
        document.querySelector(".left .content").offsetHeight + 100;
    },
    answerLike(item) {
      if (item.isLike) {
        item.likeCount--;
      } else {
        item.likeCount++;
      }
      item.isLike = !item.isLike;
    },
    like() {
      const url = `/api/u/topicquestion/like`;
      const params = {
        topicQuestionId: this.articleDetail.id,
        type: 0
      };
      this.$http.post(url, params).then(res => {
        if (res.code == "OK") {
          this.articleDetail.likeCount = res.data.likeCount;
          this.allDetail.isLike = res.data.op == "add" ? true : false;
        }
      });
    },
    collect() {
      const url = `/api/u/topicquestion/like`;
      const params = {
        topicQuestionId: this.articleDetail.id,
        type: 1
      };
      this.$http.post(url, params).then(res => {
        if (res.code == "OK") {
          this.articleDetail.collectionCount = res.data.collectionCount;
          this.allDetail.isCollect = res.data.op == "add" ? true : false;
        }
      });
    },
    refresh() {
      this.pageIndex = 1;
      this.getReply();
    },
    createAnswer() {
      var $this = this;
      if (!this.comment) {
        $this.$message.error(this.$t("global.回复内容不能为空"));
        return false;
      }
      if (this.comment.length > 5000) {
        $this.$message.error(
          `${this.$t("global.回复内容不能超过")}5000${this.$t("global.字")}`
        );
        return false;
      }
      const url = `/api/u/topicanswer/create`;
      const params = {
        content: this.comment,
        topicQuestionId: this.questionId
      };
      this.$http.post(url, params).then(res => {
        if (res.code === "OK") {
          this.comment = "";
          this.$message.success("评论成功");
          this.getDetail();
        }
      });
    },
    getReply() {
      const url = `/api/topic/findAnswerList`;
      const params = {
        topicQuestionId: this.questionId,
        answerParentId: 0,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      };
      this.$http.get(url, { params }).then(res => {
        if (res.code === "OK") {
          if (this.pageIndex === 1) {
            this.replyList = [];
          }
          const list = res.data.list.map(item => {
            item.childPageIndex = 1;
            return item;
          });
          this.replyList = [...this.replyList, ...list];
          this.replyLength = res.data.totalRecord;
        }
      });
    },
    Follow(item) {
      const url = `/api/u/relation/${!item.isFollow ? "follow" : "unfollow"}/${
        item.questionDomain.userId
      }`;
      this.$http.post(url).then(res => {
        if (res.code === "OK") {
          item.isFollow = !item.isFollow;
        }
      });
    },
    showMoreReply() {
      this.pageIndex++;
      this.getReply();
    },
    deleteArticle() {
      const url = "/api/u/topicquestion/delete";
      const params = {
        topicQuestionId: this.questionId
      };
      this.$http.post(url, params).then(res => {
        if (res.code === "OK") {
          this.$message.success("删除成功");
          this.$router.replace("/my/article");
        }
      });
    },
    reportArticle() {
      this.reportVisible = true;
    },
    getCommunity() {
      const url = `/api/article/findRelatedTopic`;
      const params = {
        articleId: this.questionId,
        pageIndex: 1,
        pageSize: 4
      };
      this.$http.get(url, { params }).then(res => {
        if (res.code === "OK") {
          this.aboutCommunity = res.data;
        }
      });
    },
    shareCkeck() {
      this.config = {
        share_url: location.href,
        title: this.articleDetail.title,
        desc: "MANA 全球新媒体艺术平台",
        pics: [
          this.shareImage ||
            "http://image.manamana.net/1547206259704_manalogo.jpg"
        ]
      };
    },
    getArticleList() {
      const params = {
        fromCount: 30,
        showCount: 3
      };
      const url = "/api/article/findHotArticle";
      this.$http
        .get(url, {
          params
        })
        .then(res => {
          if (res.code === "OK") {
            this.articleList = res.data;
          }
        });
    },
    toLinks(id) {
      this.$router.push(id);
    },
    showMoreChild(item, index) {
      item.childPageIndex++;
      const url = `/api/topic/findAnswerList`;
      const params = {
        topicQuestionId: this.questionId,
        answerParentId: item.id,
        pageIndex: item.childPageIndex,
        pageSize: this.childPageSize
      };
      this.$http.get(url, { params }).then(res => {
        if (res.code === "OK") {
          this.replyList[index].childDomain.list = [
            ...this.replyList[index].childDomain.list,
            ...res.data.list
          ];
        }
      });
    },
    getDetail() {
      const url = `/api/topic/answerInfo`;
      var params = {
        topicQuestionId: this.questionId
      };
      this.$http.get(url, { params }).then(res => {
        if (res.code === "OK") {
          this.isFixed = true;
          this.articleDetail = res.data.questionDomain;
          document.title = this.articleDetail.title;
          this.userDomain = res.data.userAccountDomain;
          this.allDetail = res.data;
          this.isUser =
            this.$store.state.peopleMessage.userId == this.articleDetail.userId;
        }
      });
    },
    shareImage() {
      let src = "";
      const imageList = this.articleDetail.content.match(/<img[^>]*>/);
      if (imageList && imageList.length) {
        imageList[0].replace(/src="([^"]*)"/, (a, b) => (src = b));
      }
      return src;
    },
    navToLogin() {
      this.$router.push(`/login?redirecturl=${window.location}`);
    },
    navToReg() {
      this.$router.push(`/reg`);
    }
  }
};
</script>
<style lang="stylus" scoped>
.article-detail {
  background: #fff;
  min-height: calc(100vh - 228px);

  .wrap {
    margin: 0 auto;
    width: 1110px;
    display: flex;
    flex-direction: row;
    padding-top: 90px;
    justify-content: space-between;

    .left {
      width: 730px;

      h4 {
        color: #0A0A0A;
        font-size: 28px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
      }

      .userInfo {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        padding: 15px 0 30px;

        a.user {
          display: flex;
          flex-direction: row;
          align-items: center;
          position: relative;

          &.userType2::before {
            content: '';
            left: 20px;
            bottom: 0;
            position: absolute;
            width: 10px;
            height: 10px;
            background: url('/static/v2/match/Verified_icon_blue_20.png');
            background-size: 10px;
          }

          img {
            width: 28px;
            height: 28px;
            border-radius: 14px;
            border: 1px solid #f5f5f5;
          }

          .view-wrap {
            height: 32px;
            padding-left: 40px;
            display: flex;
            flex-direction: row;
            align-items: center;
            cursor: initial;

            .view-icon {
              width: 14px;
              height: 10px;
            }

            .view {
              padding: 0 20px 0 4px;
            }
          }

          span {
            font-size: 14px;
            color: #B8B8B8;

            &.nickname {
              color: #333333;
              padding-right: 15px;
              padding-left: 10px;
              max-width: 535px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }

          button {
            border: 1px solid #2026CC;
            color: #2026CC;
            padding: 0 12px;
            height: 24px;
            font-size: 12px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            background: #fff;

            &.add-follow-2::before {
              content: '';
              display: inline-block;
              width: 7px;
              height: 7px;
              background: url('/static/v2/user_follow_btn_plus.png');
              background-size: 7px;
              margin-right: 4px;
              vertical-align: middle;
              margin-top: -2px;
            }

            &.following {
              border-color: #B8B8B8;
              color: #B8B8B8;
            }
          }
        }

        a.edit {
          span {
            color: #2026CC;
            font-size: 14px;
            position: relative;

            &::before {
              content: '';
              vertical-align: middle;
              display: inline-block;
              width: 16px;
              height: 16px;
              background: url('/static/v2/article/article_edit_icon.png');
              background-size: 16px;
              margin-right: 6px;
            }
          }
        }
      }

      .content {
        padding-bottom: 50px;
        color: #333333;
        font-size: 16px;
        line-height: 30px;
      }

      .content >>> img {
        max-width: 100%!important;
        height: auto!important;
      }
      .bottom {
        padding: 25px 0;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        border-top: 1px solid #EBEBEB;

        &.isFixed {
          position: fixed;
          bottom: 0;
          background: #fff;
          width: 730px;
        }

        .bottom-user {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: space-between;

          a.user {
            display: flex;
            flex-direction: row;
            align-items: center;
            position: relative;

            &.userType2::before {
              content: '';
              left: 20px;
              bottom: 0;
              position: absolute;
              width: 10px;
              height: 10px;
              background: url('/static/v2/match/Verified_icon_blue_20.png');
              background-size: 10px;
            }

            img {
              width: 28px;
              height: 28px;
              border-radius: 14px;
              border: 1px solid #f5f5f5;
            }

            span {
              font-size: 14px;
              color: #B8B8B8;

              &.nickname {
                color: #333333;
                padding-right: 15px;
                padding-left: 10px;
                max-width: 285px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
            }

            button {
              margin-right: 40px;
              border: 1px solid #2026CC;
              color: #2026CC;
              padding: 0 12px;
              height: 24px;
              font-size: 12px;
              font-family: PingFangSC-Semibold, PingFang SC;
              font-weight: 600;
              background: #fff;

              &.add-follow-2::before {
                content: '';
                display: inline-block;
                width: 7px;
                height: 7px;
                background: url('/static/v2/user_follow_btn_plus.png');
                background-size: 7px;
                margin-right: 4px;
                vertical-align: middle;
                margin-top: -2px;
              }

              &.following {
                border-color: #B8B8B8;
                color: #B8B8B8;
              }
            }
          }
        }

        .like-collect {
          ul {
            display: flex;
            flex-direction: row;

            li {
              margin-left: 22px;
              cursor: pointer;

              img {
                width: 24px;
                height: 24px;
              }

              span {
                padding-left: 4px;
                font-size: 14px;
                color: #333;
                display: inline-block;
                line-height: 24px;
                vertical-align: bottom;

                &.isActive {
                  color: #2026CC;
                }
              }
            }
          }
        }
      }

      .comment {
        padding-top: 45px;
        padding-bottom: 100px;

        h4 {
          font-size: 24px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #000;
          padding-bottom: 40px;
        }

        .textarea {
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          justify-content: flex-end;

          img {
            width: 38px;
            height: 38px;
            border-radius: 19px;
            border: 1px solid #f5f5f5;
            margin-right: 10px;
          }

          button {
            background: #2026CC;
            color: #fff;
            height: 30px;
            padding: 5px 17px;
            font-size: 14px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            margin-top: 20px;
            border-radius: 0;
            border: none;
          }
        }

        .no-login {
          height: 90px;
          background: #F5F5F5;

          p {
            display: flex;
            justify-content: center;
            padding: 34px;
            font-size: 16px;
            line-height: 22px;
            color: #666666;

            span {
              cursor: pointer;
              color: #0A0A0A;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 600;
            }
          }
        }

        .reply-wrap {
          padding-top: 20px;

          &>span {
            font-size: 15px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #999999;
          }

          .reply-list {
            &>li {
              padding: 20px 0;
              border-bottom: 1px solid #EBEBEB;
            }

            .children {
              padding: 20px 0 0 50px;

              li {
                padding-bottom: 15px;

                &:last-child {
                  padding-bottom: 0;
                }
              }

              .show-more-child {
                color: #2026CC;
                font-size: 14px;
                display: inline-block;
                margin-left: 40px;
                cursor: pointer;

                &::after {
                  content: '';
                  display: inline-block;
                  background: url('/static/v2/article/comment_open_arrow.png');
                  background-size: 9px;
                  width: 9px;
                  height: 9px;
                  margin-left: 4px;
                }
              }
            }
          }

          .reply-more {
            padding-top: 50px;
            display: flex;
            justify-content: center;

            div {
              width: 150px;
              height: 40px;
              cursor: pointer;
              border: 1px solid #333;
              text-align: center;

              span {
                color: #0A0A0A;
                font-size: 16px;
                line-height: 40px;
              }
            }
          }

          .reply-empty {
            display: flex;
            flex-direction: column;
            align-items: center;
            padding-top: 20px;

            img {
              width: 88px;
              height: 88px;
            }

            span {
              font-size: 15px;
              color: #B8B8B8;
              padding-top: 30px;
            }
          }
        }
      }
    }

    .right {
      width: 285px;

      .user-fllow {
        width: 285px;
        height: 270px;
        border: 1px solid #EBEBEB;
        display: flex;
        align-items: center;
        flex-direction: column;
        padding: 30px;
        box-sizing: border-box;

        a {
          position: relative;
          display: flex;
          align-items: center;
          flex-direction: column;
          width: 100%;

          &.userType2::before {
            content: '';
            right: calc(50% - 36px);
            top: 60px;
            position: absolute;
            width: 16px;
            height: 16px;
            background: url('/static/v2/match/Verified_icon_blue_20.png');
            background-size: 16px;
          }

          img {
            width: 80px;
            height: 80px;
            border-radius: 40px;
            border: 1px solid #f5f5f5;
          }

          h4 {
            color: #333333;
            font-size: 18px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            padding: 15px 0 5px;
            max-width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }

        p {
          width: 100%;
          height: 20px;
          white-space: nowrap;
          overflow: hidden;
          font-size: 14px;
          color: #999;
          padding-bottom: 30px;
          text-overflow: ellipsis;
          text-align: center;
        }

        .member-focus {
          width: 90px;
          height: 30px;
          padding: 5px 0;
          background: #2026CC;
          color: #fff;
          font-size: 14px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;

          &:hover {
            background: rgba(28, 33, 176, 1);
          }

          &.add-follow::before {
            content: '';
            display: inline-block;
            width: 12px;
            height: 12px;
            background: url('/static/v2/channel_follow_btn_plus.png');
            background-size: 12px;
            margin-right: 3px;
            vertical-align: middle;
            margin-top: -2px;
          }

          &.following {
            background: #fff;
            border: 1px solid #b8b8b8;
            color: #b8b8b8;
          }
        }
      }

      .hot-article, .hot-subject {
        padding-top: 70px;

        strong {
          font-size: 24px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #000;

          a {
            float: right;

            span {
              color: #2026CC;
              font-size: 16px;

              &::before {
                content: '';
                background: url('/static/v2/article/article_write_icon_sml.png');
                width: 19px;
                height: 18px;
                margin-right: 6px;
                display: inline-block;
                background-size: 19px 18px;
                vertical-align: -3px;
              }
            }
          }
        }

        ul.article-list {
          margin-top: 10px;

          li {
            padding: 20px 0;
            border-bottom: 1px solid #EBEBEB;

            p {
              font-size: 15px;
              font-family: PingFangSC-Semibold, PingFang SC;
              font-weight: 600;
              line-height: 21px;
              color: #0A0A0A;
              cursor: pointer;
              max-height: 42px;
              overflow: hidden;
            }

            .userinfor {
              padding-top: 10px;
              display: flex;
              flex-direction: row;
              align-items: center;

              a {
                display: flex;
                flex-direction: row;
                position: relative;
                align-items: center;

                &.userType2::before {
                  content: '';
                  left: 15px;
                  bottom: 0;
                  position: absolute;
                  width: 10px;
                  height: 10px;
                  background: url('/static/v2/match/Verified_icon_blue_20.png');
                  background-size: 10px;
                }

                img {
                  width: 21px;
                  height: 21px;
                  border-radius: 11px;
                  cursor: pointer;
                  border: 1px solid #f5f5f5;
                }

                span {
                  padding-left: 4px;
                  font-size: 12px;
                  color: rgba(102, 102, 102, 1);
                  cursor: pointer;

                  &:hover {
                    color: rgba(10, 10, 10, 1);
                  }
                }
              }

              .userright {
                width: 50px;
                cursor: inherit;
                flex: 1;
                text-align: right;

                img {
                  width: 14px;
                  height: 10px;
                  vertical-align: -1px;
                  cursor: inherit;
                }

                span {
                  padding-left: 0;
                  font-size: 12px;
                  font-family: NunitoSans-Regular, NunitoSans;
                  font-weight: 400;
                  color: #B8B8B8;
                  cursor: auto;
                }
              }
            }
          }
        }

        .article-list-all {
          overflow: hidden;
        }

        .showAllArticle {
          margin-top: 10px;
          float: right;

          span {
            font-size: 14px;
            color: #0A0A0A;

            &::after {
              background: url('/static/v2/match/view_all_tri.png');
              height: 9px;
              width: 7px;
              content: '';
              display: inline-block;
              background-size: 7px 9px;
              margin-left: 5px;
            }
          }
        }

        ul.subject-list {
          padding-top: 15px;

          li {
            padding: 15px 0;

            a {
              display: flex;
              flex-direction: row;

              img {
                width: 65px;
                height: 65px;
                min-width: 65px;
              }

              &>div {
                padding-left: 10px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;

                p {
                  font-size: 15px;
                  font-family: PingFangSC-Semibold, PingFang SC;
                  font-weight: 600;
                  color: #0A0A0A;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-line-clamp: 2;
                  -webkit-box-orient: vertical;
                }

                .learning {
                  padding-left: 0;

                  span {
                    font-size: 12px;
                    color: #999;
                  }

                  b {
                    color: #999;
                    padding: 0 8px 0 5px;
                    font-weight: 400;
                  }
                }
              }
            }
          }
        }
      }

      .hot-subject {
        padding-top: 70px;
        padding-bottom: 40px;
      }
    }
  }
}
</style>

<style lang="stylus">
.el-popover {
  min-width: auto;
  border-radius: 0;
}

.el-popper-more {
  min-width: auto !important;
}

.article-detail {
  .content {
    p {
      word-break: break-word;
      width: 100%;
      word-wrap: break-word;
      white-space: pre-wrap;
      &>img {
        margin-bottom: 2px;
      }

      img {
        max-width: 730px;
        height: auto;
      }
    }
    div{
      width: 100%;
    }
    ol {
      list-style: decimal inside;
    }
    li {
      list-style: inherit!important;
    }
    iframe {
      width: 100%;
      height: 400px;
    }
    pre {
      display: block;
      background: #000;
      color: #fff;
      width: 100%;
      padding: 10px;
      white-space: pre-wrap;
    }
  }

  .el-textarea {
    width: 680px;

    .el-textarea__inner {
      background: #F5F5F5;
      resize: none;
      height: 90px;
      padding: 15px;
      border: none;
      border-radius: 0;
      color: #333;
    }

    .el-textarea__inner:focus {
      border: 1px solid #2026CC;
      backGround: #fff;
      box-sizing: border-box;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/v2/article/ArticleDetail.vue